import { Link } from '@on3/ui-lib/components/Link';
import { SidebarWrapper } from '@public/components/UI/Layout/Containers/Sidebar/SidebarWrapper';

import styles from './PodcastPlayer.module.scss';

interface PodcastPlayerProps
  extends React.AllHTMLAttributes<HTMLIFrameElement> {
  allHref?: string;
}
interface IPodcastPlayerProps {
  data: PodcastPlayerProps;
}

export const PodcastPlayer = ({ data }: IPodcastPlayerProps) => {
  const {
    allHref,
    title = 'team-podcast-player',
    height = '200',
    width = '100%',
    src,
    ...iframeProps
  } = data;

  return (
    <SidebarWrapper className={styles.wrapper}>
      <h3 className={styles.title}>Podcast</h3>
      <div className={styles.iframeContainer}>
        <iframe
          height={height}
          scrolling="no"
          src={src}
          title={title}
          width={width}
          {...iframeProps}
        />
      </div>
      {allHref && (
        <Link className={styles.linkAll} href={allHref}>
          All Episodes
        </Link>
      )}
    </SidebarWrapper>
  );
};
